import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { getFrontendConfig } from '@services/frontendConfigService';
import type { FrontendConfigDTO } from '@t/api.types';

export const frontendConfigQueryKey = ['frontendConfig'] as const;

export const useFrontendConfig = (): UseQueryResult<FrontendConfigDTO, Error> =>
  useQuery<FrontendConfigDTO>({
    queryKey: frontendConfigQueryKey,
    queryFn: getFrontendConfig,
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
